





























import { Vue, Prop, Component } from 'vue-property-decorator'
import BasePanel from '@/components/BasePanel/index.vue'
@Component({
  name: 'MiniTable',
  components: { BasePanel }
})
export default class extends Vue {
  @Prop({ required: true }) private mainData: any
  @Prop({ default: true }) private sideVisible!: string
  @Prop({ default: '' }) private sideBg!: string

  get itemWidth() {
    if (this.mainData.details) {
      return (100 / this.mainData.details[0].valueDescs.length) + '%'
    } else {
      return 0
    }
  }
}

// code: null
// details: [{name: "男", values: ["55.0", "15.0", "15.5", "32.8", "-17.2", "50"],…},…]
// 0: {name: "男", values: ["55.0", "15.0", "15.5", "32.8", "-17.2", "50"],…}
// 1: {name: "女", values: ["98.0", "18.0", "32.74480450731417", "63.0", "13.0", "50"],…}
// otherDescs: null
// others: null
// remark: null
// title: "肌肉力量"
